import { createRouter, createWebHistory } from 'vue-router'
import Welcome from '../components/Welcome.vue'
import Dashboard from '../components/Dashboard.vue'
import Callback from '../components/Callback.vue'
import TwitchCallback from '../components/TwitchCallback.vue'
import Register from '../components/Register.vue'
import BuddiTest from '../components/BuddiTest.vue'
import DataLink from '../components/DataLink.vue'

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
    meta: { skipHealthCheck: true } // Skip health check on welcome page since it does its own
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: { name: 'DashboardPremium' } },
      {
        path: 'premium',
        name: 'DashboardPremium',
        component: () => import('../components/Premium.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'general',
        name: 'DashboardGeneral',
        component: () => import('../components/General.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'roleplay',
        name: 'DashboardRolePlay',
        component: () => import('../components/RolePlay.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'roleplay/tools',
        name: 'DashboardRolePlayTool',
        component: () => import('../components/RolePlayTool.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'safespace',
        name: 'DashboardSafeSpace',
        component: () => import('../components/SafeSpace.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'moderation',
        name: 'DashboardModeration',
        component: () => import('../components/Moderation.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'vip',
        name: 'DashboardVip',
        component: () => import('../components/Vip.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'ia',
        name: 'DashboardIA',
        component: () => import('../components/IntelligenceArtificielle.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'reports',
        name: 'DashboardReports',
        component: () => import('../components/Reports.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin',
        name: 'DashboardAdmin',
        component: () => import('../components/Admin.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'premium/success',
        name: 'PaymentSuccess',
        component: () => import('../components/PaymentSuccess.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback
  },
  {
    path: '/twitch-callback',
    name: 'TwitchCallback',
    component: TwitchCallback
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { skipHealthCheck: true }
  },
  {
    path: '/gift',
    name: 'GiftPremium',
    component: () => import('../components/GiftPremium.vue')
  },
  {
    path: '/test',
    name: 'BuddiTest',
    component: BuddiTest
  },
  {
    path: '/datalink',
    name: 'DataLink',
    component: DataLink,
    meta: { requiresAuth: true }
  },
  {
    path: '/logs/live',
    name: 'LiveLogsStandalone',
    component: () => import('../components/LiveLogs.vue'),
    meta: { requiresAuth: true, standalone: true }
    // Premium status validated via SignalR connection
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('discord_token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const isRegistering = localStorage.getItem('is_registering') === 'true'

  if (requiresAuth && !token) {
    next('/')
  } else if (to.path === '/' && token && !isRegistering) {
    // Rediriger vers le dashboard seulement si l'utilisateur n'est pas en cours d'inscription
    next('/dashboard')
  } else if (requiresAdmin) {
    // Vérifier si l'utilisateur est admin
    const isAdmin = localStorage.getItem('is_admin') === 'true'
    if (!isAdmin) {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router